/// <reference types="vite/client" />
/**
 * Single source for the API origin used by every renderer service.
 *
 * Resolved at RUNTIME so ONE build serves both targets correctly (no separate
 * web vs desktop bundle, no risk of shipping the wrong origin):
 *  - Desktop (Electron): the known EC2 host — exactly as before.
 *  - Browser (web): same-origin ('' -> relative `/api`, `/auth`, `/ws`), proxied
 *    by the Cloudflare Pages worker in prod, or the Vite dev proxy in local web dev.
 *  - Explicit override: `VITE_API_URL` (any value, including "") always wins.
 */
function resolveOrigin(): string {
  const fromEnv = import.meta.env.VITE_API_URL as string | undefined;
  if (fromEnv !== undefined) return fromEnv;
  if (typeof navigator !== 'undefined' && /electron/i.test(navigator.userAgent)) {
    return 'https://18.223.55.17';
  }
  return '';
}

const ORIGIN = resolveOrigin();

/** API origin (no trailing slash); '' in local-proxy mode. */
export const API_ORIGIN = ORIGIN;
/** Base for the single POST `/api` data endpoint. */
export const API_URL = `${ORIGIN}/api`;
/** Base for `/auth/*` and other root endpoints. */
export const AUTH_BASE = ORIGIN;
